/**
 * @param {Array<Object>} product - product
 * @returns {string} product info HTML
 */
export default product => `
    <div class="xlt-pdpName product-name">
        ${
            product.modelName !== null || product.shortName !== null
                ? `
                ${
                    product.modelName
                        ? `
                        <div class="product-modelname">
                            <span>${product.modelName}</span>
                        </div>
                        `
                        : ''
                }
                ${
                    product.shortName && product.mainProductGroup !== 3
                        ? `
                        <div class="product-shortname">
                            <span>${product.shortName}</span>
                        </div>
                        `
                        : ''
                }`
                : `
                <div class="product-modelname">
                    <isprint value="${product.name}"/>
                </div>
                `
        }
    </div>
`;
